/* =========================================================================
   c_anchor-nav-sp（SP専用・GSAP版）
   - SP（max-width:980px）でのみ初期化する。PC は .c_anchor-nav.is-pc が担当。
   - GSAP + ScrollTrigger はローカルアセットから遅延ロード（SP に入った時だけ）。
   - ラベルは各リンクのテキスト（ブロック設定）から取得。対象セクション側の
     data-menu-label には依存しない。
   - 幅・高さ・角丸などの固定値は rem 基準（1rem=10px 換算）で毎回算出し、
     リキッドレイアウトのスケールに追従させる。
   ========================================================================= */
(function () {
  "use strict";

  if (window.__cAnchorNavSpLoaded) {
    if (window.__cAnchorNavSpBoot) window.__cAnchorNavSpBoot();
    return;
  }
  window.__cAnchorNavSpLoaded = true;

  var mqSp = window.matchMedia("(max-width: 980px)");

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement("script");
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  // GSAP + ScrollTrigger を重複読込を避けつつ非同期ロード
  function ready(root) {
    if (window.gsap && window.ScrollTrigger) return Promise.resolve();
    if (!window.__gsapAssetLoad) {
      var gsapSrc = root.getAttribute("data-gsap-src");
      var stSrc = root.getAttribute("data-st-src");
      window.__gsapAssetLoad = loadScript(gsapSrc).then(function () {
        return loadScript(stSrc);
      });
    }
    return window.__gsapAssetLoad;
  }

  function boot() {
    if (!mqSp.matches) return;
    var roots = Array.prototype.slice.call(
      document.querySelectorAll("[data-anchor-nav-sp]")
    );
    if (!roots.length) return;

    roots.forEach(function (root) {
      if (root.__cAnchorNavSpInited) return;
      root.__cAnchorNavSpInited = true;
      ready(root)
        .then(function () {
          initInstance(root);
        })
        .catch(function () {
          console.error("GSAPまたはScrollTriggerの読み込みに失敗しました。");
        });
    });
  }

  window.__cAnchorNavSpBoot = boot;

  if (document.readyState !== "loading") {
    boot();
  } else {
    document.addEventListener("DOMContentLoaded", boot);
  }

  // PC で読み込まれたページを SP 幅にまたいだ時にも初期化する
  if (mqSp.addEventListener) {
    mqSp.addEventListener("change", boot);
  } else if (mqSp.addListener) {
    mqSp.addListener(boot);
  }

  function initInstance(menu) {
    gsap.registerPlugin(ScrollTrigger);

    var trigger = menu.querySelector(".c_anchor-nav-sp__trigger");
    var labelWindow = menu.querySelector("[data-current-section-label]");
    var plusIcon = menu.querySelector(".c_anchor-nav-sp__plus");
    var contents = menu.querySelector(".c_anchor-nav-sp__contents");
    var navEl = menu.querySelector(".c_anchor-nav-sp__nav");
    var menuLinks = Array.prototype.slice.call(
      menu.querySelectorAll(".c_anchor-nav-sp__link")
    );

    if (!trigger || !labelWindow || !contents || !menuLinks.length) return;

    var DEFAULT_LABEL =
      menu.getAttribute("data-default-label") || "";
    var DEFAULT_SECTION_ID = "__contents__";

    // 各リンクのテキスト（ブロックのラベル）を section id で引けるようにする
    var labelBySectionId = {};
    var targetSections = [];

    menuLinks.forEach(function (link) {
      var selector = link.getAttribute("href");
      if (!selector || selector.charAt(0) !== "#") return;
      var section = document.querySelector(selector);
      if (!section) return;
      var textSpan = link.querySelector("span:not(.c_anchor-nav-sp__arrow)");
      labelBySectionId[section.id] = (
        textSpan ? textSpan.textContent : link.textContent
      ).trim();
      targetSections.push(section);
    });

    if (!targetSections.length) return;

    // rem 値を現在の font-size 基準で px に換算（1rem = html の font-size）。
    // html { font-size } が vw で伸縮するリキッドレイアウトにその都度追従する。
    var px = function (remValue) {
      var base =
        Number.parseFloat(
          window.getComputedStyle(document.documentElement).fontSize
        ) || 10;
      return remValue * base;
    };

    var MAX_PANEL_WIDTH = function () {
      // window.innerWidth は縦スクロールバー幅を含むため、fixed 要素の実際の
      // 配置領域と一致する documentElement.clientWidth を使う。
      return Math.max(0, document.documentElement.clientWidth - px(3.2));
    };

    var PANEL_WIDTH = function () {
      // 最長ラベルに必要な分だけ広げ、画面幅から左右 1.6rem を引いた値で頭打ちにする。
      // あふれた文字はCSS側のellipsisで1行表示に保つ。
      var menuStyles = window.getComputedStyle(menu);
      var contentsStyles = window.getComputedStyle(contents);
      var navStyles = window.getComputedStyle(navEl);
      var linkWidth = 0;

      menuLinks.forEach(function (link) {
        var arrow = link.querySelector(".c_anchor-nav-sp__arrow");
        var text = link.querySelector(".c_anchor-nav-sp__text");
        var linkStyles = window.getComputedStyle(link);
        var gap =
          Number.parseFloat(linkStyles.columnGap || linkStyles.gap) || 0;
        var arrowWidth = arrow ? Math.ceil(arrow.getBoundingClientRect().width) : 0;
        var textWidth = text ? Math.ceil(text.scrollWidth) : 0;

        linkWidth = Math.max(linkWidth, arrowWidth + gap + textWidth);
      });

      var requiredWidth = Math.ceil(
        linkWidth +
          Number.parseFloat(contentsStyles.paddingLeft) +
          Number.parseFloat(contentsStyles.paddingRight) +
          Number.parseFloat(navStyles.paddingLeft) +
          Number.parseFloat(navStyles.paddingRight) +
          // .c_anchor-nav-sp 本体の左右ボーダー分も実幅に含める。
          // ここが不足すると、通常ラベルでも2pxだけ足りず ellipsis が出る。
          Number.parseFloat(menuStyles.borderLeftWidth) +
          Number.parseFloat(menuStyles.borderRightWidth)
      );

      return Math.min(requiredWidth, MAX_PANEL_WIDTH());
    };

    // 開いた時のパネル高さを内容から算出する（項目数・折り返しに追従）。
    // 構成（すべて rem 基準・px() で現在の font-size に換算）：
    //   パネル上 padding 1rem + リスト高さ + リスト〜閉じるの gap 1.7rem
    //   + 閉じるボタン 1.6rem + パネル下 padding 1rem
    // リスト高さは「開いた時の幅」で実測して折り返しを正しく反映する。
    var PANEL_HEIGHT = function () {
      var navHeight = 0;

      if (navEl) {
        var innerWidth = Math.max(0, PANEL_WIDTH() - 2 * px(2));
        var prevWidth = navEl.style.width;
        navEl.style.width = innerWidth + "px";
        void navEl.offsetWidth;
        navHeight = navEl.getBoundingClientRect().height;
        navEl.style.width = prevWidth;
      }

      return px(1) + navHeight + px(1.7) + px(1.6) + px(1);
    };
    var CLOSED_HEIGHT = function () {
      return px(3.4);
    };
    var PANEL_RADIUS = function () {
      return px(1.7);
    };
    var CLOSED_RADIUS = function () {
      return px(3);
    };

    var DURATION = {
      // 幅の変化（パネル開閉）とテキスト縦ロールは PC に合わせて 0.5s に統一
      panel: 0.5, // パネルの幅・高さ・角丸
      widthShrink: 0.5, // 幅の縮み（閉じる／広い状態からの収束）
      content: 0.38, // リストのフェード（開閉ロールと同尺）
      label: 0.5, // テキスト縦ロール＋ラベル幅の変化
      triggerHide: 0.18, // ラベルのフェードアウト（据え置き）
      triggerShow: 0.3, // ラベルのフェードイン（据え置き）
      // 開閉時の縦ロール（PC の --c-anchor-roll-* と同値）。
      // 開く時だけ rollDelay ぶん遅らせ、パネル 0.5s と終端を揃える。
      roll: 0.38,
      rollDelay: 0.12,
    };

    // 開閉ロールの対象＝リスト各項目の矢印とテキスト。
    // 親 .c_anchor-nav-sp__link が overflow:hidden のクリップ箱。
    var rollItems = Array.prototype.slice.call(
      menu.querySelectorAll(".c_anchor-nav-sp__arrow, .c_anchor-nav-sp__text")
    );

    var EASE = {
      panel: "power4.out",
      label: "power3.inOut",
      fade: "power2.out",
    };

    var menuTimeline = null;
    var labelTimeline = null;
    var queuedSectionRequest = null;
    var menuState = "closed";
    var currentSectionId = null;
    var pendingTargetId = null;
    var pendingTargetTimer = null;

    var duration = function (value) {
      return value;
    };

    var getCurrentLabel = function () {
      return labelWindow.querySelector(".c_anchor-nav-sp__trigger-label");
    };

    var getLabelForSection = function (section) {
      if (!section) return DEFAULT_LABEL;
      return labelBySectionId[section.id] || DEFAULT_LABEL;
    };

    var getTriggerMetrics = function () {
      var triggerStyles = window.getComputedStyle(trigger);
      var horizontalPadding =
        Number.parseFloat(triggerStyles.paddingLeft) +
        Number.parseFloat(triggerStyles.paddingRight);
      var gap =
        Number.parseFloat(triggerStyles.columnGap || triggerStyles.gap) || 0;

      return {
        horizontalPadding: horizontalPadding,
        gap: gap,
        plusWidth: plusIcon.offsetWidth,
      };
    };

    // 親要素の幅制限やellipsisの影響を受けずに、ラベル本来の表示幅を測る。
    // scrollWidth だけに頼ると、リキッド幅の小数計算で数px不足することがある。
    var getLabelContentWidth = function (labelElement) {
      if (!labelElement) return 0;

      var styles = window.getComputedStyle(labelElement);
      var measure = document.createElement("span");
      measure.textContent = labelElement.textContent;
      measure.style.position = "fixed";
      measure.style.top = "0";
      measure.style.left = "-9999px";
      measure.style.width = "max-content";
      measure.style.visibility = "hidden";
      measure.style.whiteSpace = "nowrap";
      measure.style.fontFamily = styles.fontFamily;
      measure.style.fontSize = styles.fontSize;
      measure.style.fontWeight = styles.fontWeight;
      measure.style.letterSpacing = styles.letterSpacing;
      measure.style.lineHeight = styles.lineHeight;
      document.body.appendChild(measure);
      var width = Math.ceil(measure.getBoundingClientRect().width);
      measure.remove();

      return width;
    };

    var getClosedLabelWidth = function (labelElement) {
      if (!labelElement) return 0;

      var metrics = getTriggerMetrics();
      var menuStyles = window.getComputedStyle(menu);
      var viewportLimit = Math.max(
        0,
        document.documentElement.clientWidth - px(3.2)
      );
      var availableWidth = Math.max(
        0,
        viewportLimit -
          metrics.horizontalPadding -
          metrics.gap -
          metrics.plusWidth -
          Number.parseFloat(menuStyles.borderLeftWidth) -
          Number.parseFloat(menuStyles.borderRightWidth)
      );

      return Math.min(getLabelContentWidth(labelElement), availableWidth);
    };

    var getClosedWidth = function (labelElement) {
      labelElement = labelElement || getCurrentLabel();
      if (!labelElement) {
        return px(13.7);
      }

      var metrics = getTriggerMetrics();
      var menuStyles = window.getComputedStyle(menu);
      var labelWidth = getClosedLabelWidth(labelElement);
      var requiredWidth = Math.ceil(
        metrics.horizontalPadding +
          metrics.gap +
          metrics.plusWidth +
          labelWidth +
          Number.parseFloat(menuStyles.borderLeftWidth) +
          Number.parseFloat(menuStyles.borderRightWidth)
      );
      var viewportLimit = Math.max(
        0,
        document.documentElement.clientWidth - px(3.2)
      );

      return Math.min(requiredWidth, viewportLimit);
    };

    var setLinkCurrentState = function (section) {
      menuLinks.forEach(function (link) {
        var isCurrent =
          Boolean(section) && link.getAttribute("href") === "#" + section.id;

        link.classList.toggle("is-current", isCurrent);

        if (isCurrent) {
          link.setAttribute("aria-current", "location");
        } else {
          link.removeAttribute("aria-current");
        }
      });
    };

    var createLabel = function (text) {
      var label = document.createElement("span");
      label.className = "c_anchor-nav-sp__trigger-label";
      label.textContent = text;
      return label;
    };

    var replaceLabelImmediately = function (text) {
      var label = createLabel(text);
      labelWindow.replaceChildren(label);

      var labelWidth = getClosedLabelWidth(label);
      var closedWidth = getClosedWidth(label);

      gsap.set(label, {
        yPercent: 0,
        clearProps: "opacity",
      });

      gsap.set(labelWindow, {
        width: labelWidth,
      });

      if (menuState === "closed") {
        gsap.set(menu, {
          width: closedWidth,
        });
      }

      // 新しいラベル要素を実寸監視の対象に付け替える（Webフォント遅延ロード対策）
      observeCurrentLabel();

      return closedWidth;
    };

    var animateLabel = function (text) {
      var oldLabel = getCurrentLabel();

      if (!oldLabel || oldLabel.textContent === text) {
        return;
      }

      var nextLabel = createLabel(text);
      labelWindow.append(nextLabel);

      var oldWidth = getLabelContentWidth(oldLabel);
      var nextWidth = getLabelContentWidth(nextLabel);
      var nextLabelWidth = getClosedLabelWidth(nextLabel);
      var nextClosedWidth = getClosedWidth(nextLabel);
      var labelChangeDuration =
        nextWidth < oldWidth ? DURATION.widthShrink : DURATION.label;

      gsap.set(nextLabel, {
        yPercent: 120,
      });

      var timeline = gsap.timeline({
        defaults: {
          overwrite: "auto",
        },
        onComplete: function () {
          oldLabel.remove();

          gsap.set(nextLabel, {
            yPercent: 0,
            clearProps: "transform",
          });

          if (labelTimeline === timeline) {
            labelTimeline = null;
          }

          // 現在ラベルが nextLabel に変わったので実寸監視を付け替える
          observeCurrentLabel();

          // アニメーション中に発生した最新の現在地変更を、完了後に続けて反映
          flushQueuedSectionRequest();
        },
      });

      labelTimeline = timeline;
      timeline.addLabel("labelChange", 0);

      timeline
        .to(
          oldLabel,
          {
            yPercent: -120,
            duration: duration(labelChangeDuration),
            ease: EASE.label,
          },
          "labelChange"
        )
        .to(
          nextLabel,
          {
            yPercent: 0,
            duration: duration(labelChangeDuration),
            ease: EASE.label,
          },
          "labelChange"
        )
        .to(
          labelWindow,
          {
            width: nextLabelWidth,
            duration: duration(labelChangeDuration),
            ease: EASE.label,
          },
          "labelChange"
        );

      if (menuState === "closed") {
        timeline.to(
          menu,
          {
            width: nextClosedWidth,
            duration: duration(labelChangeDuration),
            ease: EASE.label,
          },
          "labelChange"
        );
      }
    };

    var applyCurrentSection = function (section, options) {
      section = section || null;
      options = options || {};
      var animate = options.animate !== false;
      var force = options.force === true;

      var sectionId = section ? section.id : DEFAULT_SECTION_ID;
      var label = getLabelForSection(section);

      if (!force && currentSectionId === sectionId) {
        return;
      }

      var shouldAnimate = animate && currentSectionId !== null;

      currentSectionId = sectionId;

      setLinkCurrentState(section);

      if (shouldAnimate) {
        animateLabel(label);
      } else {
        replaceLabelImmediately(label);
      }
    };

    var flushQueuedSectionRequest = function () {
      if (!queuedSectionRequest || labelTimeline) {
        return;
      }

      var request = queuedSectionRequest;
      queuedSectionRequest = null;
      applyCurrentSection(request.section, request.options);
    };

    var setCurrentSection = function (section, options) {
      section = section || null;
      options = options || {};
      var animate = options.animate !== false;
      var force = options.force === true;

      var sectionId = section ? section.id : DEFAULT_SECTION_ID;
      var queuedSectionId =
        queuedSectionRequest && queuedSectionRequest.section
          ? queuedSectionRequest.section.id
          : DEFAULT_SECTION_ID;

      // ラベルアニメーション中は中断せず、最新の現在地だけ保持して完了後に反映
      if (labelTimeline) {
        if (
          !force &&
          (currentSectionId === sectionId ||
            (queuedSectionRequest && queuedSectionId === sectionId))
        ) {
          return;
        }

        queuedSectionRequest = {
          section: section,
          options: {
            animate: animate,
            force: force,
          },
        };

        return;
      }

      applyCurrentSection(section, {
        animate: animate,
        force: force,
      });
    };

    var getSectionAtDetectionLine = function () {
      var detectionLine = window.innerHeight * 0.4;
      var previousSection = null;

      for (var i = 0; i < targetSections.length; i++) {
        var section = targetSections[i];
        var rect = section.getBoundingClientRect();

        if (rect.top <= detectionLine && rect.bottom > detectionLine) {
          return section;
        }

        if (rect.top <= detectionLine) {
          previousSection = section;
        }
      }

      return previousSection;
    };

    var clearPendingTarget = function (options) {
      options = options || {};
      pendingTargetId = null;

      if (pendingTargetTimer) {
        window.clearTimeout(pendingTargetTimer);
        pendingTargetTimer = null;
      }

      if (options.sync) {
        setCurrentSection(getSectionAtDetectionLine());
      }
    };

    var startPendingTarget = function (sectionId) {
      clearPendingTarget();
      pendingTargetId = sectionId;

      // scrollend 未対応環境でも保留状態が残らないようにする
      pendingTargetTimer = window.setTimeout(function () {
        clearPendingTarget({ sync: true });
      }, 2000);
    };

    var activateFromScrollTrigger = function (section) {
      // メニューリンクで移動中は、途中で通過する別セクションの上書きを防ぐ
      if (pendingTargetId && (!section || section.id !== pendingTargetId)) {
        return;
      }

      if (pendingTargetId && section && section.id === pendingTargetId) {
        clearPendingTarget();
      }

      setCurrentSection(section);
    };

    var createCurrentSectionTriggers = function () {
      targetSections.forEach(function (section, index) {
        var previousSection = index > 0 ? targetSections[index - 1] : null;

        ScrollTrigger.create({
          id: "anchor-nav-sp-" + section.id,
          trigger: section,
          start: "top 40%",
          end: "bottom 40%",
          invalidateOnRefresh: true,

          onEnter: function () {
            activateFromScrollTrigger(section);
          },

          onEnterBack: function () {
            activateFromScrollTrigger(section);
          },

          // 上方向へ戻ってセクションを抜けた場合は、一つ前のセクションまたは既定へ
          onLeaveBack: function () {
            activateFromScrollTrigger(previousSection);
          },
        });
      });
    };

    var killMenuTimeline = function () {
      if (!menuTimeline) {
        return;
      }

      menuTimeline.kill();
      menuTimeline = null;
    };

    // 開閉ロールを始める前に、走っている「現在セクション切替」のロールを確定させる。
    // getCurrentLabel() は窓内の *最初の* 要素を返すため、切替中はまだ残っている
    // 旧ラベルを掴んでしまう。そのまま yPercent を動かすと overwrite で旧ラベルの
    // 退出ツイーンが殺され、新旧2つが同じ位置に並んで文字が重なる。
    // 戻り値＝この先ずっと残る「現在ラベル」。
    var settleLabelSwap = function () {
      // 切替中に積まれた予約はここで自前に確定させる。
      // （progress(1) の onComplete が flushQueuedSectionRequest() を呼び、
      //   新しい切替ロールが始まってまた2つになるのを防ぐ）
      var queued = queuedSectionRequest;
      queuedSectionRequest = null;

      if (labelTimeline) {
        labelTimeline.progress(1);
        labelTimeline = null;
      }

      if (queued) {
        applyCurrentSection(queued.section, { animate: false, force: true });
      }

      var all = labelWindow.querySelectorAll(".c_anchor-nav-sp__trigger-label");
      // 取りこぼした旧ラベルを除去し、窓の中を必ず1つにする
      for (var i = 0; i < all.length - 1; i++) {
        all[i].remove();
      }

      return all[all.length - 1] || null;
    };

    var openMenu = function () {
      if (menuState === "open" || menuState === "opening") {
        return;
      }

      killMenuTimeline();
      menuState = "opening";

      // ＋を前面・クリック可能にし、トリガー面のヒットを無効化（is-open）
      menu.classList.add("is-open");
      trigger.setAttribute("aria-expanded", "true");
      contents.setAttribute("aria-hidden", "false");

      // 走っている切替ロールを先に確定させ、「この先残るラベル」を掴む
      var openingLabel = settleLabelSwap();
      var currentWidth = menu.getBoundingClientRect().width;
      var panelWidth = PANEL_WIDTH();
      var openingWidth = Math.max(currentWidth, panelWidth);
      var needsWidthShrink = openingWidth > panelWidth;

      gsap.set(contents, {
        visibility: "visible",
        pointerEvents: "auto",
      });

      var timeline = gsap.timeline({
        defaults: {
          overwrite: "auto",
        },
        onComplete: function () {
          menuState = "open";

          if (menuTimeline === timeline) {
            menuTimeline = null;
          }
        },
      });

      menuTimeline = timeline;

      timeline
        // 現在ラベルは「下へ抜ける」（開く＝すべてが上から下へ動く）。
        // labelWindow が overflow:hidden のクリップ箱。
        .to(
          openingLabel,
          {
            yPercent: 120,
            duration: duration(DURATION.roll),
            ease: EASE.panel,
          },
          0
        )
        // 抜けきったら窓ごと隠す。開いている間にスクロールで現在地が変わっても
        // （animateLabel が走っても）×の隣にラベルが顔を出さないようにする保険。
        .set(labelWindow, { autoAlpha: 0 }, duration(DURATION.roll))
        // ＋を 45° 回転させて × にする（その場に残す）
        .to(
          plusIcon,
          {
            rotate: 45,
            duration: duration(DURATION.panel),
            ease: EASE.panel,
          },
          0
        )
        .to(
          menu,
          {
            width: openingWidth,
            height: PANEL_HEIGHT(),
            borderRadius: PANEL_RADIUS(),
            duration: duration(DURATION.panel),
            ease: EASE.panel,
          },
          0
        )
        .fromTo(
          contents,
          {
            autoAlpha: 0,
          },
          {
            autoAlpha: 1,
            duration: duration(DURATION.content),
            ease: EASE.fade,
          },
          0
        )
        // リスト項目は「上から降りてくる」。パネルが広がり始めてから少し遅らせる。
        .fromTo(
          rollItems,
          {
            yPercent: -120,
          },
          {
            yPercent: 0,
            duration: duration(DURATION.roll),
            ease: EASE.panel,
          },
          duration(DURATION.rollDelay)
        );

      if (needsWidthShrink) {
        timeline.to(
          menu,
          {
            width: panelWidth,
            duration: duration(DURATION.widthShrink),
            ease: EASE.panel,
          },
          duration(0.2)
        );
      }
    };

    var closeMenu = function () {
      if (menuState === "closed" || menuState === "closing") {
        return;
      }

      killMenuTimeline();
      menuState = "closing";

      // ＋を通常のトリガー（開くボタン）に戻す
      menu.classList.remove("is-open");
      trigger.setAttribute("aria-expanded", "false");
      contents.setAttribute("aria-hidden", "true");

      // 走っている切替ロールを先に確定させ、「この先残るラベル」を掴む。
      // 閉じ幅もこのラベル基準で計算する（旧ラベル基準だと幅がズレる）。
      var closingLabel = settleLabelSwap();
      var closedWidth = getClosedWidth(closingLabel);

      var timeline = gsap.timeline({
        defaults: {
          overwrite: "auto",
        },
        onComplete: function () {
          menuState = "closed";

          gsap.set(contents, {
            visibility: "hidden",
            pointerEvents: "none",
          });

          var currentLabel = getCurrentLabel();

          if (currentLabel) {
            gsap.set(labelWindow, {
              width: Math.ceil(currentLabel.scrollWidth),
            });

            gsap.set(menu, {
              width: getClosedWidth(currentLabel),
            });
          }

          // 閉じた後は高さ・角丸のインライン px を解除し、CSS の rem 値
          // （height:3.4rem / border-radius:3rem）に戻す。以降はリキッド
          // レイアウトのスケールに追従して高さが自動で伸縮する。
          gsap.set(menu, {
            clearProps: "height,borderRadius",
          });

          if (menuTimeline === timeline) {
            menuTimeline = null;
          }
        },
      });

      menuTimeline = timeline;

      timeline
        // リスト項目は「上へ抜ける」（閉じる＝すべてが下から上へ動く）
        .to(
          rollItems,
          {
            yPercent: -120,
            duration: duration(DURATION.roll),
            ease: EASE.panel,
          },
          0
        )
        // ロールが見えるだけの尺をかけて消す。パネルの収縮（power4.out）は
        // この時点でほぼ収束しているので、細いピルの中に文字が残ることはない。
        .to(
          contents,
          {
            autoAlpha: 0,
            duration: duration(DURATION.content),
            ease: EASE.fade,
          },
          0
        )
        .set(
          contents,
          {
            visibility: "hidden",
            pointerEvents: "none",
          },
          duration(DURATION.content)
        )
        .to(
          menu,
          {
            width: closedWidth,
            duration: duration(DURATION.widthShrink),
            ease: EASE.panel,
          },
          0
        )
        .to(
          menu,
          {
            height: CLOSED_HEIGHT(),
            borderRadius: CLOSED_RADIUS(),
            duration: duration(DURATION.panel),
            ease: EASE.panel,
          },
          0
        )
        // ＋を 0° に戻す（× → ＋）
        .to(
          plusIcon,
          {
            rotate: 0,
            duration: duration(DURATION.panel),
            ease: EASE.panel,
          },
          0
        )
        // 現在ラベルは「下から立ち上がる」。開いている間に animateLabel が走って
        // yPercent が 0 に戻っている場合があるため、fromTo で毎回 120 から始める。
        .set(labelWindow, { autoAlpha: 1 }, 0)
        .fromTo(
          closingLabel,
          {
            yPercent: 120,
          },
          {
            yPercent: 0,
            duration: duration(DURATION.roll),
            ease: EASE.panel,
          },
          0
        );
    };

    // トリガー＝開閉トグル。開いている時は CSS(is-open) により ＋ だけがクリック可能。
    trigger.addEventListener("click", function () {
      if (menuState === "open" || menuState === "opening") {
        closeMenu();
        trigger.focus();
      } else {
        openMenu();
      }
    });

    menuLinks.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault();

        var targetSelector = link.getAttribute("href");
        var targetSection =
          targetSelector && targetSelector.charAt(0) === "#"
            ? document.querySelector(targetSelector)
            : null;

        if (!targetSection) {
          return;
        }

        // 押した瞬間にリンクのカレントクラスとラベルを目的地へ変更
        startPendingTarget(targetSection.id);

        setCurrentSection(targetSection, {
          animate: false,
          force: true,
        });

        closeMenu();

        // 長いページで scrollIntoView({ behavior: 'smooth' }) が途中で止まることがあるため、
        // 現在のページ座標を明示して移動する（PC版アンカーナビと同じ方式）。
        // scrollTo は scroll-margin-top を無視するため、着地オフセットを手動で引く
        // （c_policies の h2 や、scroll-margin を持つターゲット向け）。
        var scrollMarginTop =
          parseFloat(window.getComputedStyle(targetSection).scrollMarginTop) || 0;
        var targetTop =
          targetSection.getBoundingClientRect().top +
          (window.pageYOffset || document.documentElement.scrollTop || 0) -
          scrollMarginTop;
        window.scrollTo({
          top: targetTop,
          behavior: "smooth",
        });
      });
    });

    document.addEventListener("click", function (event) {
      var isActive = menuState === "open" || menuState === "opening";

      if (!isActive || menu.contains(event.target)) {
        return;
      }

      closeMenu();
    });

    document.addEventListener("keydown", function (event) {
      var isActive = menuState === "open" || menuState === "opening";

      if (event.key !== "Escape" || !isActive) {
        return;
      }

      closeMenu();
      trigger.focus();
    });

    // プログラム移動を手動操作で中断した場合は、現在位置を優先して即時再判定
    var cancelPendingNavigation = function () {
      if (pendingTargetId) {
        clearPendingTarget({ sync: true });
      }
    };

    window.addEventListener("wheel", cancelPendingNavigation, {
      passive: true,
    });

    window.addEventListener("touchstart", cancelPendingNavigation, {
      passive: true,
    });

    window.addEventListener("scrollend", function () {
      if (pendingTargetId) {
        clearPendingTarget({ sync: true });
      }
    });

    // closed ピルの幅を現在ラベルの実寸から測り直す（フォント差し替え・ズーム・
    // リキッド伸縮でラベル幅が変わった時の共通処理）。
    var refitClosedFromLabel = function () {
      var currentLabel = getCurrentLabel();
      if (!currentLabel) return;

      gsap.set(labelWindow, {
        width: getClosedLabelWidth(currentLabel),
      });

      if (menuState === "closed") {
        gsap.set(menu, {
          width: getClosedWidth(currentLabel),
        });
      }
    };

    // ラベル要素の実寸を監視し、Webフォントの遅延ロードなどで寸法が変わったら
    // closed ピル幅を測り直す。初期測定が古いフォールバックフォントのまま残り、
    // ピルが広がりすぎる不具合の対策。ラベルは差し替わるため観測対象も付け替える。
    var labelResizeObserver = null;
    var observeCurrentLabel = function () {
      if (!labelResizeObserver) return;
      labelResizeObserver.disconnect();
      var currentLabel = getCurrentLabel();
      if (currentLabel) labelResizeObserver.observe(currentLabel);
    };

    if (window.ResizeObserver) {
      labelResizeObserver = new ResizeObserver(function () {
        // アニメーション／アンカー移動中は触らない。ScrollTrigger.refresh() は
        // 現在位置を保存・復元するため、smooth scroll の途中で呼ぶと移動先より
        // 手前の位置へ戻してしまう。
        if (
          labelTimeline ||
          menuTimeline ||
          menuState !== "closed" ||
          pendingTargetId
        )
          return;
        refitClosedFromLabel();
      });
    }

    // 横幅が変わった時だけパネル幅を測り直して合わせる（高さは変えない）。
    // モバイルのアドレスバー開閉など「縦だけ」の変化では再計算しない。
    var lastViewportWidth = window.innerWidth;
    var resizeTimer = null;

    var fitPanelWidth = function () {
      if (menuState === "open") {
        // 開いている時：幅は rem 換算のパネル幅、高さは内容から再算出して追従。
        // （幅が変わると折り返しが変わり必要な高さも変わるため両方を測り直す）
        gsap.set(menu, {
          width: PANEL_WIDTH(),
          height: PANEL_HEIGHT(),
          borderRadius: PANEL_RADIUS(),
        });
      } else {
        refitClosedFromLabel();
      }

      ScrollTrigger.refresh();
    };

    window.addEventListener("resize", function () {
      if (window.innerWidth === lastViewportWidth) {
        return;
      }
      lastViewportWidth = window.innerWidth;

      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(fitPanelWidth, 150);
    });

    // 初期状態を先に確定してから ScrollTrigger を作成
    setCurrentSection(getSectionAtDetectionLine(), {
      animate: false,
      force: true,
    });

    // ここまでで replaceLabelImmediately が実測 px の幅を入れたので、
    // 「初期化前は内容幅で省略しない」CSS フォールバックを解除する。
    // これより前に付けると、CSS の暫定 rem 幅でラベルが一瞬省略されて見える。
    menu.classList.add("is-ready");

    // 閉じた状態の高さ・角丸は CSS の rem 値に任せる（GSAP でインライン px 固定しない）。
    // 幅だけはラベル依存で動的に決まるため replaceLabelImmediately 側で設定済み。
    gsap.set(menu, {
      boxShadow: "none",
      clearProps: "height,borderRadius",
    });

    gsap.set(trigger, {
      autoAlpha: 1,
    });

    // ＋は 0°（＝プラス）、現在ラベルは表示から開始
    gsap.set(plusIcon, {
      rotate: 0,
    });

    gsap.set(labelWindow, {
      autoAlpha: 1,
    });

    gsap.set(contents, {
      autoAlpha: 0,
      visibility: "hidden",
      pointerEvents: "none",
    });

    // 閉じた状態の初期値：リスト項目は上へ退避（開く時に上から降りてくる起点）
    gsap.set(rollItems, {
      yPercent: -120,
    });

    createCurrentSectionTriggers();
    ScrollTrigger.refresh();

    // ラベルの実寸監視を開始（初期ラベルを対象に）。以降はラベル差し替え時に
    // observeCurrentLabel() で対象を付け替える。
    observeCurrentLabel();

    // Webフォントの読み込み完了後にも念のため測り直す（ResizeObserver 非対応環境の保険）
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        if (labelTimeline || menuTimeline) return;
        refitClosedFromLabel();
        ScrollTrigger.refresh();
      });
    }
  }
})();
